import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.MainComponent,
    {
      tag: "component",
      attrs: { width: _setup.isMobile ? undefined : 360, scrollable: "" },
      model: {
        value: _setup.isVisible,
        callback: function ($$v) {
          _setup.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c(
        VCard,
        {
          staticClass: "text--text",
          attrs: { "max-height": _setup.isMobile ? undefined : 500 },
        },
        [
          !_setup.isMobile
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center pa-4" },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-4",
                          attrs: { color: "icon-secondary", size: "24" },
                          on: {
                            click: function ($event) {
                              _setup.isVisible = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          ui-icon-close-not-a-circle\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-h6 text--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _setup.t("Дарим скидку 300 ₽ за честный отзыв", {
                                ns: _setup.language,
                              })
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(VDivider),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.isMobile
            ? _c("div", { staticClass: "d-flex align-center px-4 pt-6 mb-2" }, [
                _c("div", { staticClass: "text-h6 text--text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t("Дарим скидку 300 ₽ за честный отзыв", {
                          ns: _setup.language,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            VCardText,
            { staticClass: "px-0", class: _setup.isMobile ? "py-0" : "py-4" },
            [
              _c(
                "div",
                { staticClass: "text-body-1 text-secondary--text px-4 mb-2" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(
                          "Важно любое ваше мнение: позитивное или негативное.",
                          { ns: _setup.language }
                        )
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _setup.openEventPayload.lpuList
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-subtitle-1 text--text px-4 mt-5 mb-2",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _setup.t(
                                "Можно оставить отзыв о приёме в клинике",
                                { ns: _setup.language }
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_setup.openEventPayload.lpuList, function (lpu) {
                      return _c(
                        "a",
                        {
                          directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                          key: lpu.doctorPrsLandingUrl,
                          staticClass:
                            "d-flex align-center text-decoration-none px-4 py-2",
                          attrs: { href: lpu.doctorPrsLandingUrl },
                        },
                        [
                          _c("div", { staticClass: "mr-4" }, [
                            _c("div", { staticClass: "text-body-1" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(lpu.name) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-body-2 text-secondary--text",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(lpu.address) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(VSpacer),
                          _vm._v(" "),
                          _c(VIcon, { attrs: { color: "icon-secondary" } }, [
                            _vm._v(
                              "\n            ui-icon-arrow-right\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            VSheet,
            {
              class: _setup.isMobile ? "px-4 pb-4 mt-5" : "pa-2",
              attrs: {
                elevation:
                  _setup.isMobile || !_setup.openEventPayload.lpuList ? 0 : 8,
              },
            },
            [
              _c(
                VBtn,
                {
                  staticClass: "primary--text",
                  attrs: { color: "bg-primary", depressed: "", block: "" },
                  on: { click: _setup.handleClickButton },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.t("Хорошо", { ns: _setup.language })) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }